<template>
<div style="height: 100%; overflow-y: scroll; display: flex; justify-content: center; width: 100%;">
  <div class="container">
    <h1>An Understanding of Visual Metaphor Usage in Infographics</h1>
    <div style="display: flex; gap: 20px;">
        <p class="conference-info">IEEE VIS 2025</p>
        <p class="submission-id">Online Submission ID: 1240</p>
    </div>
    <!-- <div class="teaser-container">
      <img src="../assets/teaser.png" alt="Teaser Image" class="teaser-img">
      <p class="teaser-caption">
        <strong>Fig. 1:</strong> The comparison between the traditional methods and the proposed interactive data bias probing method. (a) Traditional methods focus on explicit biases, missing implicit biases in less obvious attributes. (b) Our method adaptively detects both explicit and implicit biases, using a plant-growth-based visualization to help users track bias evolution and mitigating through targeted data augmentation.
      </p>
    </div> -->
    
    <div class="section-header-wrapper">
      <div class="abstract-header">Abstract</div>
    </div>
    <div class="abstract-section-content">
      <p>
        Visual metaphors illuminate infographics by employing graphical representations from more familiar (source) domains, such as dandelion, to explain complex concepts in more abstract (target) domains, such as information propagation. They achieve semantically resonant designs by correlating the source and target domains. Despite their benefits, designing effective visual metaphors remains a challenge, particularly for novice designers, as it involves forming a metaphoric correspondence between a concept and the visual element(s) in the graphical representation. In this paper, informed by 2,174 metaphoric infographics collected from multiple sources, we contribute a structured design space based on the “why-what-how” framework: (1) Why is the visual metaphor applied? (2) What data is expressed through the visual metaphor? (3) How is the visual metaphor conceptually established? We encapsulate the data and design space in a recommendation tool that facilitates designers in exploring the design space. The design space and tool are evaluated through a user study, demonstrating their effectiveness in improving the understanding of visual metaphor designs and supporting the metaphor ideation process. All supplemental materials and the tool are available at https://bit.ly/43yCIbY.
      </p>
    </div>
    
    <div class="section-header-wrapper">
      <div class="supplemental-header">Supplemental Materials</div>
    </div>
    <div class="section-content">
      <div class="download-link">
        <div>Supplemental document: <a href="/files/supp.pdf"><u>link</u></a></div>
        <div>Collected dataset & Study materials: <a href="https://drive.google.com/drive/folders/1IY3FiqXqIdnzGlhnrBM6IPdcofAlmiof?usp=drive_link"><u>Google Drive link</u></a></div>
        <!-- <div>Study materials: <a href=""><u>link</u></a></div> -->
      </div>
    </div>
    
    
    <div class="section-header-wrapper">
      <div class="video-header">Video</div>
    </div>
    <div class="video-section-content">
      <div class="video-container">
        <!-- <iframe src="/files/video.mp4" allowfullscreen></iframe> -->
        <video controls preload="metadata" style="width: 100%;">
            <source src="/files/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
        </video>
      </div>
    </div>
    
    <div class="section-header-wrapper">
      <div class="supplemental-header">Recommendation Tool: MetaSpark</div>
    </div>
    <div class="section-content">
      <div class="download-link">
        <div>Online demo: <a href="/demo"><u>link</u></a></div>
        <div style="font-weight: bold; font-size: 0.8em;"><u>(Note: Due to the cost associated with large language model usage, the tool currently offers limited access via predefined prompts.)</u></div>
      </div>
      <img src="../assets/home/system.png" alt="Tool Image" class="teaser-img">
    </div>
    
    <div class="section-header-wrapper">
      <div class="supplemental-header">Design Space</div>
    </div>
    <div class="section-content">
        <Space></Space>
    </div>
    
    
    
    <!-- <div class="section-header-wrapper">
      <div class="supplemental-header">Supplemental Materials</div>
    </div>
    <div class="section-content">
      <div class="download-link">
        <span class="material-icons">picture_as_pdf</span>
        <a href="../assets/data.zip">Download Supplemental PDF</a>
      </div>
    </div> -->
  </div>
</div>
</template>

<script>
import Space from '../components/Space.vue';
export default {
  name: 'MetaSpark',
  components: {
    Space
  },
  data() {
    return {
      // Add any reactive data here if needed in the future
    }
  }
}
</script>

<style scoped>
/* CSS variables should be defined globally or imported from a global stylesheet */
/* For component-specific variables, we can define them directly */

/* Component variables */
.container {
    /* --primary-blue: #0a3d62; */
    --primary-blue: #000000;
    --light-blue: #e6f7ff;
    --light-gray: #f5f5f5;
    --light-peach: #fff3e0;
}

.container {
  max-width: 1420px;
  margin: 20px auto;
  height: fit-content;
  background-color: white;
  /* box-shadow: 0 0 20px rgba(0,0,0,0.05); */
  padding: 30px;
  border-radius: 8px;
}

h1 {
  color: var(--primary-blue);
  font-size: 2.2em;
  font-weight: 500;
  margin-bottom: 5px;
  line-height: 1.3;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaeaea;
}

.submission-id {
  color: #666;
  font-size: 1em;
  /* margin-top: 0; */
  /* margin-bottom: 15px; */
  font-style: italic;
}

.conference-info {
  /* margin-top: 10px; */
  color: #666;
  font-style: italic;
  /* margin-bottom: 30px; */
}

.section-header-wrapper {
  margin-left: 0px;
  position: relative;
}

.abstract-header {
  background-color: var(--light-peach);
  color: var(--primary-blue);
  font-weight: 600;
  font-size: 1.6em;
  padding: 3px 12px;
  border-radius: 8px 8px 0 0;
  margin: 40px 0 0 0;
  display: inline-block;
  z-index: 10;
  position: relative;
  /* box-shadow: 0 -2px 5px rgba(0,0,0,0.05); */
}

.abstract-section-content {
  background-color: var(--light-peach);
  padding: 25px;
  border-radius: 8px;
  text-align: justify;
  line-height: 1.6;
  margin-top: -8px;
  /* box-shadow: 0 3px 10px rgba(0,0,0,0.08); */
  border: 1px solid rgba(0,0,0,0.05);
}

.video-header {
  background-color: #e6f2ff;
  color: var(--primary-blue);
  font-weight: 600;
  font-size: 1.6em;
  padding: 3px 12px;
  border-radius: 8px 8px 0 0;
  margin: 40px 0 0 0;
  display: inline-block;
  z-index: 10;
  position: relative;
  /* box-shadow: 0 -2px 5px rgba(0,0,0,0.05); */
}

.video-section-content {
  background-color: #e6f2ff;
  padding: 25px;
  border-radius: 8px;
  margin-top: -8px;
  /* box-shadow: 0 3px 10px rgba(0,0,0,0.08); */
  border: 1px solid rgba(0,0,0,0.05);
}

.supplemental-header {
  background-color: #f7fbff;
  color: var(--primary-blue);
  font-weight: 600;
  font-size: 1.6em;
  padding: 3px 12px;
  border-radius: 8px 8px 0 0;
  margin: 40px 0 0 0;
  display: inline-block;
  z-index: 10;
  position: relative;
  /* box-shadow: 0 -2px 5px rgba(0,0,0,0.05); */
}

.section-content {
  border-radius: 8px;
  padding: 25px;
  margin-top: -8px;
  background-color: #f7fbff;
  /* box-shadow: 0 3px 10px rgba(0,0,0,0.08); */
  border: 1px solid rgba(0,0,0,0.05);
}

.teaser-container {
  text-align: center;
  margin: 50px 0 30px 0;
  position: relative;
}

.teaser-img {
  max-width: 100%;
  box-shadow: none;
  border: none;
  transition: transform 0.3s ease;
}

.teaser-img:hover {
  transform: scale(1.01);
}

.teaser-caption {
  font-size: 0.9em;
  color: #555;
  margin-top: 15px;
  text-align: justify;
  line-height: 1.5;
  background-color: #fafafa;
  padding: 15px;
  border-radius: 5px;
  border-left: 3px solid var(--primary-blue);
}

.download-link {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: start;
  margin: 10px 0;
  transition: all 0.2s ease;
  padding: 10px;
  border-radius: 4px;
  font-size: 1.35em;
}

.download-link:hover {
  background-color: rgba(10, 61, 98, 0.05);
}

.material-icons {
  margin-right: 10px;
  color: var(--primary-blue);
}

a {
  color: #0a3d62;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

a:hover {
  text-decoration: none;
  color: #1e88e5;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  margin: 10px 0;
  border-radius: 6px;
  overflow: hidden;
  /* box-shadow: 0 4px 12px rgba(0,0,0,0.1); */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

p {
  margin-bottom: 15px;
}

strong {
  color: #0a3d62;
}
</style>